import {
  CHAT_BULK_ATTACHMENTS_FOLDER,
  EXECUTABLE_ATTACHMENT_EXTENSIONS,
  MAX_BULK_MESSAGE_ATTACHMENTS,
  VIDEO_ATTACHMENT_EXTENSIONS,
} from "@fitness-app/data-models/entities/ChatAttachment";

import { type StorageConfig, type UploadValidatorConfig } from "~/components/Upload/types";

// 40 MB
const MAX_FILE_SIZE_IN_BYTES = 40485760;

export const getUploadConfig = (
  channelId: string,
): { validatorConfig: UploadValidatorConfig; storageConfig: StorageConfig } =>
  ({
    validatorConfig: {
      maxFilesListSize: MAX_FILE_SIZE_IN_BYTES * 10,
      maxFilesListLength: 10,
      maxFileSize: MAX_FILE_SIZE_IN_BYTES,
    },
    storageConfig: {
      isPublicBucket: false,
      bucketName: "chat",
      objectPath: `${channelId}`,
    },
  }) as const;

/** Attachments of a message sent to many clients: the author's own folder, see the storage policy. */
export const getBulkMessageUploadConfig = (
  userId: string,
): { validatorConfig: UploadValidatorConfig; storageConfig: StorageConfig } =>
  ({
    validatorConfig: {
      maxFilesListSize: MAX_FILE_SIZE_IN_BYTES * MAX_BULK_MESSAGE_ATTACHMENTS,
      maxFilesListLength: MAX_BULK_MESSAGE_ATTACHMENTS,
      maxFileSize: MAX_FILE_SIZE_IN_BYTES,
      // Replaces the uploader's default exclusions, so the executables are listed here too.
      excludedExtensions: [...EXECUTABLE_ATTACHMENT_EXTENSIONS, ...VIDEO_ATTACHMENT_EXTENSIONS],
    },
    storageConfig: {
      isPublicBucket: false,
      bucketName: "chat",
      objectPath: `${CHAT_BULK_ATTACHMENTS_FOLDER}/${userId}`,
    },
  }) as const;
